module.exports = __webpack_public_path__ + "img/lyrics2.229f83e6.jpg";